export default __webpack_public_path__ + "static/media/preview.0a674069.gif";